import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=5a6b68cd&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"
import style0 from "./Preloader.vue?vue&type=style&index=0&id=5a6b68cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b68cd",
  null
  
)

export default component.exports